import { Grid, TableBody, TableCell, TableContainer, TableHead, TableRow, Table } from '@material-ui/core';
import { TextBox as InputText } from '../../../../Core/FormInput';
import { useContext, useEffect, useState } from 'react';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';

export const InspectionRoadTest = ({ Paper, classes }) => {
    const { state, handleInputs } = useContext(InspectionCheCkContaxt);

    const [show, setShow] = useState({
        showAxle1: false,
        showAxle2: false,
        showAxle3: false,
        showAxle4: false
    });

    let handleAxle = () => {
        let showAxle1 = false;
        let showAxle2 = false;
        let showAxle3 = false;
        let showAxle4 = false;
        if (state.vehicleNoOfAxles) {
            switch (state.vehicleNoOfAxles) {
                case 1:
                    showAxle1 = true;
                    break;
                case 2:
                    showAxle1 = true;
                    showAxle2 = true;
                    break;
                case 3:
                    showAxle1 = true;
                    showAxle2 = true;
                    showAxle3 = true;
                    break;
                case 4:
                    showAxle1 = true;
                    showAxle2 = true;
                    showAxle3 = true;
                    showAxle4 = true;
                    break;

                default:
                    break;
            }
        } else {
            showAxle1 = true;
            showAxle2 = true;
            showAxle3 = true;
            showAxle4 = true;
        }

        setShow((st) => ({
            ...st,
            showAxle1: showAxle1,
            showAxle2: showAxle2,
            showAxle3: showAxle3,
            showAxle4: showAxle4
        }));
    };

    useEffect(() => {
        handleAxle();
    }, [state.vehicleNoOfAxles]);

    return (
        <Grid item container direction="row" xs={12} sm={12} md={6} lg={6}>
            <TableContainer component={Paper}>
                <div
                    style={{
                        border: '1px solid rgba(0,0,0,0.2)'
                    }}
                >
                    <h3 className={classes.title}>
                        Road Test &nbsp;<small>(Brake Temperature Assessment)</small>
                    </h3>
                </div>
                <Table aria-label="simple table" className={classes.paper}>
                    <TableHead>
                        <TableRow>
                            <TableCell width="5%">Side</TableCell>
                            {show.showAxle1 && (
                                <TableCell align="center" colSpan={2}>
                                    Axle 1
                                </TableCell>
                            )}
                            {show.showAxle2 && (
                                <TableCell align="center" colSpan={2}>
                                    Axle 2
                                </TableCell>
                            )}
                            {show.showAxle3 && (
                                <TableCell align="center" colSpan={2}>
                                    Axle 3
                                </TableCell>
                            )}
                            {show.showAxle4 && (
                                <TableCell align="center" colSpan={2}>
                                    Axle 4
                                </TableCell>
                            )}
                        </TableRow>

                        <TableRow>
                            <TableCell width="5%"></TableCell>
                            {show.showAxle1 && (
                                <TableCell width="10%" align="Left">
                                    Before
                                </TableCell>
                            )}
                            {show.showAxle1 && (
                                <TableCell width="10%" align="Left">
                                    After
                                </TableCell>
                            )}
                            {show.showAxle2 && (
                                <TableCell width="10%" align="Left">
                                    Before
                                </TableCell>
                            )}
                            {show.showAxle2 && (
                                <TableCell width="10%" align="Left">
                                    After
                                </TableCell>
                            )}
                            {show.showAxle3 && (
                                <TableCell width="10%" align="Left">
                                    Before
                                </TableCell>
                            )}
                            {show.showAxle3 && (
                                <TableCell width="10%" align="Left">
                                    After
                                </TableCell>
                            )}
                            {show.showAxle4 && (
                                <TableCell width="10%" align="Left">
                                    Before
                                </TableCell>
                            )}
                            {show.showAxle4 && (
                                <TableCell width="10%" align="Left">
                                    After
                                </TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th" width="5%">
                                <b>O/S</b>
                            </TableCell>

                            {show.showAxle1 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="osBeforeBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[0]?.osBeforeBrakeTemperatureAxle}
                                        onChange={handleInputs(1)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle1 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="osBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[0]?.osBrakeTemperatureAxle}
                                        onChange={handleInputs(1)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle2 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="osBeforeBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[1]?.osBeforeBrakeTemperatureAxle}
                                        onChange={handleInputs(2)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle2 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="osBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[1]?.osBrakeTemperatureAxle}
                                        onChange={handleInputs(2)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle3 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        npm
                                        start
                                        name="osBeforeBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[2]?.osBeforeBrakeTemperatureAxle}
                                        onChange={handleInputs(3)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle3 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        npm
                                        start
                                        name="osBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[2]?.osBrakeTemperatureAxle}
                                        onChange={handleInputs(3)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle4 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="osBeforeBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[3]?.osBeforeBrakeTemperatureAxle}
                                        onChange={handleInputs(4)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle4 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="osBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[3]?.osBrakeTemperatureAxle}
                                        onChange={handleInputs(4)}
                                    />
                                </TableCell>
                            )}
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" width="5%">
                                <b>N/S</b>
                            </TableCell>

                            {show.showAxle1 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="nsBeforeBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[0]?.nsBeforeBrakeTemperatureAxle}
                                        onChange={handleInputs(1)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle1 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="nsBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[0]?.nsBrakeTemperatureAxle}
                                        onChange={handleInputs(1)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle2 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="nsBeforeBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[1]?.nsBeforeBrakeTemperatureAxle}
                                        onChange={handleInputs(2)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle2 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="nsBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[1]?.nsBrakeTemperatureAxle}
                                        onChange={handleInputs(2)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle3 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="nsBeforeBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[2]?.nsBeforeBrakeTemperatureAxle}
                                        onChange={handleInputs(3)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle3 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="nsBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[2]?.nsBrakeTemperatureAxle}
                                        onChange={handleInputs(3)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle4 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="nsBeforeBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[3]?.nsBeforeBrakeTemperatureAxle}
                                        onChange={handleInputs(4)}
                                    />
                                </TableCell>
                            )}
                            {show.showAxle4 && (
                                <TableCell>
                                    <InputText
                                        placeholder="°C"
                                        name="nsBrakeTemperatureAxle"
                                        value={state.inspectionSheetAxlesVM[3]?.nsBrakeTemperatureAxle}
                                        onChange={handleInputs(4)}
                                    />
                                </TableCell>
                            )}
                        </TableRow>
                        <TableRow></TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
};
